import React from 'react';
import styles from './index.module.scss';

export default function ZeroState() {
  return <div className={styles.container}>No store found!</div>;
}
